/**
 * The ACTAS roster's own figures — the anchor, the block order and the 8-day
 * cycle — kept as configuration rather than constants, so that a roster
 * change becomes a fixture update instead of a code change.
 *
 * Every figure below carries its provenance:
 *
 * - **`anchorDate`** — `brief.md`: "Anchor: 1A starts AM on Tue 26/05/2026."
 *   Source: Oscar. 26 May 2026 is a Tuesday, which `src/engine/civil.ts`'s
 *   own tests already assert independently.
 * - **`blockOrder`** — `brief.md`: eight blocks, "each block runs the
 *   identical pattern, offset by 1 day", in this order. The array index *is*
 *   the block's offset in days — the whole reason this is an ordered array
 *   rather than a set.
 * - **`cycleLength` / `cycleDayShifts`** — `brief.md`: an 8-day cycle,
 *   `AM → D → PM → N → off ×4`. Cycle days 0–3 map to the four shifts in
 *   order; 4–7 are off.
 * - **`shifts`** — `ROSTER_SHIFTS` from `./roster-shifts`, itself sourced
 *   from Oscar, 8 August 2026 (see that file's header).
 * - **`horizon`** — `PLAN.md` decision A7: six months forward, three months
 *   back.
 *
 * These four figures — anchor, block order, cycle shape and horizon — are
 * the whole of what a roster change would touch. The 64-cell golden fixture
 * in the roster engine pins today's behaviour against them, so a change here
 * shows up as a fixture update rather than a silent shift in what the app
 * tells a paramedic they are working.
 */

import type { RosterConfig } from '../engine/types'
import { ROSTER_SHIFTS } from './roster-shifts'

export const ACTAS_ROSTER: RosterConfig = {
  anchorDate: '2026-05-26',
  blockOrder: ['1A', '1B', '2A', '2B', '3A', '3B', '4A', '4B'],
  cycleLength: 8,
  cycleDayShifts: ['AM', 'D', 'PM', 'N', null, null, null, null],
  shifts: ROSTER_SHIFTS,
  horizon: { monthsBack: 3, monthsForward: 6 },
}
